/* Package JSON Import will be here */
import { message } from 'antd';
import 'antd/dist/antd.css';
/* Package JSON Import will be here */

/* Project Import will be here */
import { Constants } from '../../../config/appConstants';
/* Project Import will be here */

export const MessageBox = (messageContent, type) => {
    if (typeof messageContent === Constants.OBJECT) {
        messageContent = messageContent.message;
    }
    message.destroy();

    if (type === Constants.SUCCESS) {
        return message.success(messageContent);
    }

    else if (type === Constants.ERROR) {
        message.error(messageContent);
    }

    else if (type === Constants.INFO) {
        message.info(messageContent);
    }

    else if (type === Constants.WARNING) {
        message.warning(messageContent);
    }

    else if (type === Constants.WARN) {
        message.warn(messageContent);
    }

    else if (type === Constants.LOADING) {
        message.loading(messageContent);
    }
};